import { render, staticRenderFns } from "./TrainingVideoPlayer.vue?vue&type=template&id=780d4d96&scoped=true"
import script from "./TrainingVideoPlayer.vue?vue&type=script&lang=ts"
export * from "./TrainingVideoPlayer.vue?vue&type=script&lang=ts"
import style0 from "./TrainingVideoPlayer.vue?vue&type=style&index=0&id=780d4d96&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "780d4d96",
  null
  
)

export default component.exports